import React, { useLayoutEffect } from 'react'
import moment from 'moment'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"
import VideoThumbnail from 'react-video-thumbnail'
import withQuery from 'with-query'
import './VideosViewer.css'


const MAX_SIZE_THUMB = 50

// the videothumbnail also make a GET request to /video/:name
const customRenderThumb = children => {
    return children.map(item => {
        const urlSplit = item.props.src.split('_')
        let videoName = urlSplit.slice(2).join('_').split('.')[0]
        if (videoName.length > MAX_SIZE_THUMB) {
            videoName = videoName.slice(0, MAX_SIZE_THUMB)
            videoName = videoName + '...'
        }

        const noPersonalizedPoster = !item.props.poster
        return noPersonalizedPoster ? (
            <div
                className='videoThumbnail'
                key={`videoThumbnail:${item.props.src}`}
                onClick={sizeCalc}
            >
                <VideoThumbnail
                    snapshotAtTime={0}
                    videoUrl={item.props.src}
                />
                <p>{videoName}</p>
            </div>
        ) : (
            <div
                className='videoThumbnail'
                key={`videoThumbnail:${item.props.src}`}
                onClick={sizeCalc}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px', // Space between image and text
                    padding: '4px',
                    cursor: 'pointer',
                    marginLeft: "3%",
                    marginTop: "3%",
                    marginBottom: "3%",
                    width: '100%',
                }}
            >
                <img
                    src={item.props.poster}
                    alt="Video thumbnail"
                    style={{
                        width: '100px', // Fixed width
                        height: 'auto',
                        objectFit: 'cover',
                        borderRadius: '4px'
                    }}
                />
                <p style={{
                    margin: 0,
                    wordWrap: 'break-word', // Allow text to break onto new lines
                    overflowWrap: 'break-word', // Alternative property for better support
                    whiteSpace: 'normal', // Allow normal line wrapping
                    flex: 1 // Take remaining space
                }}>{videoName}</p>
            </div>
        )
    })
}

const customRenderItem = item => {
    const urlSplit = item.props.src.split('_')
    let videoName = urlSplit.slice(2).join('_').split('.')[0]

    return (
        <div className='videoItem'>
            {item}
            <p>{videoName}</p>
        </div>
    )
}

const heightCalc = () => {
    /* dynamic calculation of playlist height */
    const videoItemDiv = document.querySelectorAll('.vids .slider-wrapper.axis-horizontal')[0]
    const playlistDiv = document.querySelectorAll('.vids .thumbs-wrapper.axis-vertical')[0]
    if (videoItemDiv && playlistDiv){
        playlistDiv.style.height = videoItemDiv.offsetHeight + 'px'
    }
}
const widthCalc = () => {
    /* Safari canvas from video workaround */
    const thumbsBadWidth = document.querySelectorAll('.vids .react-thumbnail-generator video')
    const thumbsGoodWidth = document.querySelectorAll('.vids .react-thumbnail-generator img')
    const thumbsTitle = document.querySelectorAll('.vids .videoThumbnail p')

    /* Convert NodeList to Array then calculate max width */
    if (thumbsBadWidth.length > 0) {
        const thumbsGoodWidthSizeArray = [...thumbsGoodWidth].map(img => img.width)
        const thumbMaxWidth = Math.max(...thumbsGoodWidthSizeArray)
        if (thumbMaxWidth ) {
            thumbsBadWidth.forEach( thumb => {
                thumb.style.width = thumbMaxWidth + 'px'
            })
        }
    }
    if (thumbsTitle.length > 0) {
        const thumbsTitleSizeArray = [...thumbsTitle].map(p => p.offsetWidth)
        const thumbTitleMax = Math.max(...thumbsTitleSizeArray)
        if (thumbTitleMax) {
            thumbsTitle.forEach( p => {
                p.style.width = thumbTitleMax + 'px'
            })
        }
    }
}
const sizeCalc = () => {
    heightCalc()
    widthCalc()
}


const VideosViewer = props => {
    const [currentIndex, setCurrentIndex] = React.useState(0) // just to retrigger rendering of the videos not the real index

    useLayoutEffect(() => {
        if (props.data.videos?.length !== 0) {
            window.addEventListener('resize', heightCalc)
            return () => {
                window.removeEventListener('resize', heightCalc)
            }
        }
    }, [props.data.videos?.length])

    return (
        <div className='vids'>

            <Carousel
                renderItem={customRenderItem}
                renderThumbs={customRenderThumb}
                showThumbs={!props.noThumbnail}
                showIndicators={false}
                showStatus={false}
                showArrows={props.showArrows}
                swipeable={false}
                onChange={(index) => {
                    setTimeout(() => {
                        setCurrentIndex(index)
                    }, 100) // ~100ms before forcing React to remount video so control bar layout resets
                }}
            >
                { props.data.videos?.map(video => {
                    const fullDate = moment(video.date).format('YYYY-MM-DD_HH-mm-ss')
                    const fullPosterDate = video.poster && moment(video.poster.date).format('YYYY-MM-DD_HH-mm-ss')
                    const groupModelId = props.groupModel && props.groupModel.id
                    const poster = video.poster && withQuery(`/image/${fullPosterDate}_${video.poster.name}`, {accessId: props.accessId, groupModelId})
                    return (
                        <video
                            key={`${video.date}_${video.name}_${currentIndex}`}
                            src={withQuery(`/video/${fullDate}_${video.name}`, {accessId: props.accessId, groupModelId})}
                            poster={poster}
                            onCanPlay={heightCalc}
                            style={{
                                margin: 'auto',
                                justifyContent: 'center',
                                aspectRatio: '4 / 3',
                                objectFit: 'contain',
                                display: 'flex',
                                alignItems: 'center',
                                height: '100%',
                                width: '100%'
                            }}
                            controls
                            controlsList='nodownload'
                        />
                    )
                })}
            </Carousel>
        </div>
    )
}

export default VideosViewer
